import ReactDOM from 'react-dom/client'
import { ToastProvider } from 'react-toast-notifications'
import { QueryClient, QueryClientProvider } from 'react-query'
import { ReactQueryDevtools } from 'react-query/devtools'
import { PrivyProvider } from '@privy-io/react-auth'

import App from './App'
import { authClient } from './auth'
import * as serviceWorker from './serviceWorker'
import './scss/main.scss'
import './poap-eth'
import AOS from 'aos'

console.info('Running version:', process.env.REACT_APP_VERSION)

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
    },
  },
})

async function main() {
  // We only need the auth client in the backoffice routes
  const path = window.location.pathname.toLowerCase()
  if (path.startsWith('/backoffice') || path.startsWith('/admin') || path.startsWith('/callback')) {
    await authClient.init()
  }
  AOS.init({
    once: true,
  })
  const root = ReactDOM.createRoot(document.getElementById('root')!)
  root.render(
    <QueryClientProvider client={queryClient}>
      <ToastProvider>
        <PrivyProvider
          appId={`${process.env.REACT_APP_PRIVY_APP_ID}`}
          config={{
            loginMethods: ['wallet'],
            appearance: {
              logo: '',
            },
          }}
        >
          <App auth={authClient} />
        </PrivyProvider>
      </ToastProvider>

      {/* DevTools Setup */}
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>,
  )
}

main().catch((err) => {
  console.error('Error starting app')
  console.error(err)
})

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
